import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/wincent.js';
import { casesEntity } from '../cases/index.js';
import q from '../query.js';
export const wincentPredictionKey = (id) => `wincent-prediction-${id}`;
export const useWincentPrediction = (valid, case_, context) => q.query(wincentPredictionKey(case_.caseId), () => api.getCasePrediction(case_.caseId, { ...context, case: case_ }), [...keys.read.item(casesEntity, case_.caseId)], { enabled: valid });
//# sourceMappingURL=index.js.map